export const sendContactSupportEmail = (baseUrl: string): string => `${baseUrl}/profile/v1/support/email`;
